import { AxiosError } from 'axios'
import { APP_EVENTS } from '@/constants'
interface FormattedError extends Error {
  status?: number | null
  error_code?: string
}

interface ErrorHandlerOptions {
  ignoreUnauthorized?: boolean
}

const checkUnauthorized = (error: AxiosError): void => {
  if (error.response?.status === 401 || error.response?.status === 419) {
    document.dispatchEvent(new CustomEvent(APP_EVENTS.SESSION_EXPIRED))
  }
}

const errorHandler = (
  error: AxiosError,
  options: ErrorHandlerOptions = {}
): FormattedError => {
  const formattedError: FormattedError = new Error()
  const json: any = error?.toJSON ? error.toJSON() : {}

  if (!options?.ignoreUnauthorized) {
    checkUnauthorized(error)
  }

  if (error.response) {
    formattedError.status = error.response.status
    formattedError.message =
      extractFirstError(error) || error.response.data?.error || error.response.data?.message || json?.message

    if (error.response.data?.error_code) {
      formattedError.error_code = error.response.data.error_code
    }
  } else if (error.request) {
    formattedError.message = json?.message
  } else {
    formattedError.message = error.message
  }

  return formattedError
}

export default errorHandler

const extractFirstError = (error: AxiosError): string | null => {
  const errorObject = error.response?.data?.errors
  if (!errorObject) return null
  const errorList = Object.values(errorObject).reduce(
    (list: any[], array: any) => {
      return [...list, ...array]
    },
    []
  )
  return errorList.length ? (errorList[0] as string) : null
}
